"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../hooks");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ReportNotifications = _ref => {
  let {
    accountId,
    children,
    projectId,
    reportId,
    setActivePageName,
    setReportUrl,
    setReportId,
    onReportComplete
  } = _ref;
  const {
    notifySuccess,
    notifyError
  } = (0, _hooks.useNotifications)();
  const {
    reportService,
    reportType,
    reportFormat,
    isOpen,
    reportTitle
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const {
    trackOnComplete
  } = (0, _hooks.useTrackEvent)({
    reportService,
    reportType,
    reportFormat
  });
  const successNotification = () => {
    trackOnComplete('success');
    return !isOpen && notifySuccess({
      i18nKey: 'notifications.reportSucceeded',
      values: {
        reportTitle
      }
    });
  };
  const errorNotification = () => {
    trackOnComplete('failed');
    return notifyError({
      i18nKey: 'notifications.reportFailed',
      values: {
        reportTitle
      }
    });
  };
  (0, _hooks.usePollUntilReportCompletion)({
    isOpen,
    reportId,
    accountId,
    projectId,
    setActivePageName,
    setReportUrl,
    setReportId,
    errorNotification,
    successNotification,
    onReportComplete
  });
  return children;
};
ReportNotifications.propTypes = {
  accountId: _propTypes.default.string,
  projectId: _propTypes.default.string,
  reportId: _propTypes.default.string,
  setActivePageName: _propTypes.default.func,
  setReportUrl: _propTypes.default.func,
  onReportComplete: _propTypes.default.func
};
var _default = exports.default = ReportNotifications;